export enum ECisoModuleTabs {
  SecurityPosture = 'security-posture',
  OperationalMetric = 'operational-metric',
  Compliance = 'compliance',
}

export type CISOTabItem = {
  label: string;
  value: ECisoModuleTabs;
  description?: string;
  noDescription?: boolean;
};
